/*
 * A guest's first screen (VISUAL.md §7.16): the team member's card with the guest's own lead.
 *
 * A guest is a person outside Team members — a partner, a client — who sees the conversations they
 * are added to and the channels of their groups, and nothing else of the team's. The card says so in
 * its lead, once, because a smaller teamBase that never says why it is smaller reads as a broken one.
 * The card is the member's (`FirstRunMember.tsx`) with two sentences of the guest's own: the lead,
 * and the one for "no channel yet", because a guest does not find channels by joining them —
 * somebody adds them, or a group of theirs owns one.
 *
 * Seen once, through the same per-account flag as the member's (`core.shell.seen_welcome`).
 */

import type { ComponentProps } from "react"
import { FirstRunMember } from "./FirstRunMember.tsx"

export function FirstRunGuest(
	props: Omit<ComponentProps<typeof FirstRunMember>, "leadKey" | "whereNoneKey">,
) {
	return (
		<FirstRunMember
			{...props}
			leadKey="shell.firstRun.guest.lead"
			whereNoneKey="shell.firstRun.guest.whereNone"
		/>
	)
}
